// import Cookies from 'universal-cookie';
import axios from 'axios';
import Cookies from "universal-cookie";
import format from 'date-fns/format';
import {
  guardAaOnlyPage,
  resolveBankingEntryPage,
} from "./config/aaRollout";

const cookies = new Cookies();

// export function getGlid(){
//     const cookie = new Cookies();

//     var glid = '';

//     let visitorData = cookie.get('loginCookkie');
//     if (visitorData) {
//         visitorData = visitorData.split("|");

//         let sd = [];
//         visitorData.map((data) => {
//             sd = data.split("=")
//             if (sd[0] == "glid") {
//                 glid = sd[1]
//             }
//         })
//     }
//     return glid;
// }

export async function writeAddInfo(gst, udyam, bisAdd, bisPin, bisOwn, resAdd, resPin, resOwn, glid, ak) {

  if (udyam == "") {
    udyam = "NA";
  }

  let apiURL = process.env.REACT_APP_ADDINFO_API_URL || "https://www.hellotrade.com/api/v1/addInfo";

  let inputData = {
    glid: glid,
    udhyam: udyam,
    gst: gst,
    bisAdd: bisAdd,
    bissPin: bisPin,
    bissOwn: bisOwn,
    resAdd: resAdd,
    resPin: resPin,
    resOwn: resOwn,
    ak: ak
  };

  let formData = new FormData();
  for (let key in inputData) {
    formData.append(key, inputData[key]);
  }

  try {
    const response = await axios({
      method: 'post',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      url: apiURL,
      data: formData,
      timeout: 10000,
    });

    if (response.data.CODE === "200" && response.data.MESSAGE === 'SUCCESS') {
      return "success";
    } else {
      return "error";
    }
  } catch (error) {
    console.error("Error in writing additional info:", error);
    return "error";
  }
}


// export function setUserSession(glid, gst, bisAdd, bisPin){
//     const userInfo = {
//         glid,
//         gst,
//         bisAdd,
//         bisPin
//     };

//     sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
// }

// export function getUserSession() {
//     const userInfoString = sessionStorage.getItem('userInfo');
//     if (userInfoString) {
//         const userInfo = JSON.parse(userInfoString);
//         return userInfo;
//     } else {
//         console.log('No userInfo found in session storage.');
//         return "";
//     }
// }

export const banks = [
  "Bank of Baroda",
  "Bank of India",
  "Bank of Maharashtra",
  "Canara Bank",
  "Central Bank of India",
  "Indian Bank",
  "Indian Overseas Bank",
  "Punjab National Bank",
  "Punjab & Sind Bank",
  "State Bank of India",
  "Union Bank of India",
  "UCO Bank",
  "Axis Bank Ltd.",
  "Bandhan Bank Ltd.",
  "CSB Bank Ltd.",
  "City Union Bank Ltd.",
  "DCB Bank Ltd.",
  "Dhanlaxmi Bank Ltd",
  "Federal Bank Ltd.",
  "HDFC Bank Ltd",
  "ICICI Bank Ltd.",
  "Induslnd Bank Ltd",
  "IDFC First Bank Ltd",
  "Jammu & Kashmir Bank Ltd.",
  "Karnataka Bank Ltd.",
  "Karur Vysya Bank Ltd",
  "Kotak Mahindra Bank Ltd.",
  "Lakshmi Vilas Bank Ltd",
  "Nainital Bank Ltd.",
  "RBL Bank Ltd.",
  "South Indian Bank Ltd.",
  "Tamilnad Mercantile Bank Ltd.",
  "YES Bank Ltd.",
  "IDBI Bank Ltd.",
  "DBS Bank",
  "State Bank of Mauritius",
  // "Australia & New Zealand Banking Group",
  "Bank of Bahrain and Kuwait",
  "AB Bank",
  "Sonali Bank",
  "Bank of Nova Scotia",
  "Bank of China",
  // "Industrial & Commercial Bank of China",
  "Danske Bank",
  "Saxo Bank",
  "Barclays",
  "HSBC Bank India",
  "Standard Chartered India",
  "BNP Paribas",
  "Société Générale",
  // "Crédit Agricole Corporate and Investment Bank",
  "Deutsche Bank",
  "Bank Maybank Indonesia",
  "Mizuho Corporate Bank",
  "MUFG Bank",
  // "Sumitomo Mitsui Banking Corporation",
  "ABN AMRO",
  "Rabobank",
  "Doha Bank",
  "Qatar National Bank",
  "Sberbank",
  "NatWest Group",
  "United Overseas Bank",
  "FirstRand Bank",
  "Industrial Bank of Korea",
  "KEB Hana Bank",
  "Kookmin Bank",
  "Shinhan Bank",
  "Woori Bank",
  "Bank of Ceylon",
  "Handelsbanken",
  "Credit Suisse",
  "CTBC Bank",
  "Krung Thai Bank",
  "Abu Dhabi Commercial Bank",
  "Emirates NBD",
  "First Abu Dhabi Bank",
  "American Express",
  "Bank of America",
  "JPMorgan Chase",
  "Other"
];

export const BUSINESS_LOAN_JOURNEY_PAGES = {
  PI_DETAILS: 1,
  OTP: 2,
  BANKING: 3,
  THANKS: 4,
  MORE_DETAILS: 5,
  UPLOAD_DOCUMENTS: 6,
  MASKED_MOBILE: 7,
  MASKED_MOBILE_OTP: 8,
  CHOICE: 10,
  AA_FLOW: 11,
  FLDG_THANKS: 12,
  NET_BANKING: 13,
};

/**
 * Banking "system" pages: Choice (10), manual (3), AA (11), Net Banking (13).
 * Stage+substage mapping can route a revisiting user to any one of these.
 */
export const BANKING_SYSTEM_PAGES = [
  BUSINESS_LOAN_JOURNEY_PAGES.CHOICE,
  BUSINESS_LOAN_JOURNEY_PAGES.BANKING,
  BUSINESS_LOAN_JOURNEY_PAGES.AA_FLOW,
  BUSINESS_LOAN_JOURNEY_PAGES.NET_BANKING,
];

/** Pages that are valid entry points INTO the banking system from outside (form/otp/resume). */
export const BANKING_ENTRY_PAGES = [
  BUSINESS_LOAN_JOURNEY_PAGES.CHOICE,
  BUSINESS_LOAN_JOURNEY_PAGES.BANKING,
];

export const isBankingSystemPage = (pageId) =>
  BANKING_SYSTEM_PAGES.includes(Number(pageId));

export const isBankingEntryPage = (pageId) =>
  BANKING_ENTRY_PAGES.includes(Number(pageId));

export async function writeLogs(glid, input, output, status, serviceName, code, issue, reqTime, respTime, totalTime, ak = "") {
  // const payload = { glid, input, output, status, serviceName, code, issue, reqTime, respTime, totalTime, ak };
  const url = process.env.REACT_APP_SET_LOANS_LOGS_API || "https://loans.indiamart.com/api/v1/setLogs";

  if (!ak) {
    ak = getAk();
  }

  const formData = new URLSearchParams();

  formData.append("glid", glid);
  formData.append("ak", ak || "");
  formData.append("input", input);
  formData.append("output", output);
  formData.append("status", status);
  formData.append("serviceName", serviceName);
  formData.append("code", code);
  formData.append("issue", issue);
  formData.append("reqTime", reqTime);
  formData.append("respTime", respTime);
  formData.append("totalTime", totalTime);

  try {
    const response = await axios.post(url, formData, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });

    return response.data;
  } catch (error) {
    console.error("Error from SetLogs API =>", error.response?.data || error.message);
    return { error: error.response?.data || error.message };
  }
};

export async function writeHtFrontLog({
  glid,
  ak,
  input = "",
  output = "",
  issue = "",
  serviceName = "WRITE_FRONTEND_LOG",
  source = "FRONTEND_LOG",
  status = "INFO",
  code = "0",
  modid = "",
  reqTime = "",
  respTime = "",
  totalTime = "0"
}) {

  if (!glid) {
    glid = getGlid();
  }
  if (!ak) {
    ak = getAk();
  }

  const baseUrl = process.env.REACT_APP_HT_BASE_URL || "https://www.hellotrade.com";

  const formData = new FormData();
  formData.append("glid", glid);
  formData.append("ak", ak);
  formData.append("input", input);
  formData.append("output", output);
  formData.append("issue", issue);
  formData.append("serviceName", serviceName);
  formData.append("source", source);
  formData.append("status", status);
  formData.append("code", code);
  formData.append("modid", modid);
  formData.append("reqTime", reqTime);
  formData.append("respTime", respTime);
  formData.append("totalTime", totalTime);

  try {
    const response = await fetch(`${baseUrl}/api/v1/writeHtFrontLog`, {
      method: "POST",
      body: formData,
    });

    const result = await response.json();

    if (result.CODE == "200") {
      console.log("HT log written successfully");
    } else {
      console.warn("HT log write failed", result);
    }
  } catch (err) {
    console.error("Error writing HT log:", err);
  }
}


export function gatrack(category, action, label, value = null, userType = null, src = null) {
  const payload = { category, action, label, value, userType, src };

  console.log("GA TRACK =>", payload);


  if (!window.dataLayer) {
    console.error("GTM Data Layer not found!");
    return;
  }
  // console.log("window imgtm => ", window.imgtm);
  // console.log("window layer => ", window.dataLayer);

  window.dataLayer.push({ 'event': 'IMEvent', 'eventCategory': category, 'eventAction': action, 'eventLabel': label, 'eventValue': value, 'eventUserType': userType, 'eventSrc': src });

}

export function getCurrentIST() {
  const options = { timeZone: "Asia/Kolkata", hour12: false };
  return new Date().toLocaleString("en-US", options);
}


export function openFinagg(link) {
  //console.log("link number =>", link);


  if (link != "") {
    window.location.href = link;
  } else {
    alert("Please enter a valid link");
  }

}

export function isJourneyDB(glid) {
  return true;

  //this need to be removed
  const glidStr = String(glid);

  const allowedGlids = ['13035342', '140700990', '98959272', '69778761', '241147852', '242123102', '110906762', '92124971', '197523013'];

  if (allowedGlids.includes(glidStr)) {
    return true;
  }

  const lastDigit = parseInt(glidStr.slice(-1), 10);
  const validEndings = [5, 6, 7, 8, 9];

  return validEndings.includes(lastDigit);
}


export async function sendOtp(num) {

  const getConsDataURL = process.env.REACT_APP_GEN_OTP_HT_URL || "https://www.hellotrade.com/api/v1/genOTP";

  const payload = new URLSearchParams();
  payload.append("num", num);

  try {
    const response = await axios.post(getConsDataURL, payload, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      timeout: 10000,
    });

    const data = response?.data;
    if (data?.CODE == "200") {
      return "success";
    } else {
      return "failed";
    }
  } catch (error) {
    console.error("An error occurred in sendOtp:", error);
    return "error";
  }

}

export async function resendOtp(num) {

  const getConsDataURL = process.env.REACT_APP_RESEND_OTP_HT_URL || "https://www.hellotrade.com/api/v1/resendOTP";

  const payload = new URLSearchParams();
  payload.append("num", num);

  try {
    const response = await axios.post(getConsDataURL, payload, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      timeout: 10000,
    });

    const data = response?.data;
    if (data?.CODE == "200") {
      return "success";
    } else {
      return "failed";
    }
  } catch (error) {
    console.error("An error occurred in resendOtp:", error);
    return "error";
  }

}

const CUST_PROFILE_NUM = (process.env.REACT_APP_CUST_PROFILE_NUM || "[]")
  .replace(/[\[\]'"]/g, "")
  .split(",")
  .map(v => v.trim());

export async function validateOtp(num, otp) {
  const url = process.env.REACT_APP_VERIFY_OTP_HT_URL_V2 || "https://www.hellotrade.com/api/v1/validateOtpV2";

  const payload = new URLSearchParams();
  payload.append("num", num);
  payload.append("otp", otp);
  payload.append("fullPath", window.location.pathname + window.location.search);

  try {
    const response = await axios.post(url, payload, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      timeout: 1000000,
    });

    const data = response?.data;

    if (data?.CODE == "200" && data?.RESULT) {
      // success → return RESULT object
      return data.RESULT;
    }
    // failure → return empty string 
    return "";
  } catch (error) {
    console.error("An error occurred in validateOtp:", error);
    return "";
  }
}

export function setLoginCookies(glid, ak, phone, encNum) {
  // Build ht_visitor string
  const ht_visitor = `glid=${glid || ""}|mobile=${phone || ""}|encnum=${encNum || ""}`;

  // Build ht_iss string
  const ht_iss = `t=${ak || ""}`;

  // Expire in 24 hours
  const oneDay = 24 * 60 * 60; // seconds

  cookies.set("ht_visitor", ht_visitor, { path: "/", maxAge: oneDay });
  cookies.set("ht_iss", ht_iss, { path: "/", maxAge: oneDay });

  setClarityGlid(glid);
}

/** Tag the Microsoft Clarity session with the user's glid. */
export function setClarityGlid(glid) {
  if (!glid) glid = getGlid();
  if (!glid) return;
  try {
    if (typeof window !== "undefined" && typeof window.clarity === "function") {
      window.clarity("identify", String(glid));
      window.clarity("set", "glid", String(glid));
    }
  } catch (e) {
    // Clarity not ready yet; index.html sets the glid on load as a fallback.
  }
}

function parseKeyValueCookie(raw) {
  if (typeof raw !== "string" || !raw) return {};
  let decoded = raw;
  if (decoded.includes("%")) {
    try {
      decoded = decodeURIComponent(decoded);
    } catch (error) {
      console.warn("Unable to decode cookie value", error);
    }
  }
  const out = {};
  for (const part of decoded.split("|")) {
    const idx = part.indexOf("=");
    if (idx === -1) continue;
    const key = part.slice(0, idx).trim();
    const val = part.slice(idx + 1).trim();
    if (key) out[key] = val;
  }
  return out;
}

export function checkLoginCookies() {
  const visitorRaw = cookies.get("ht_visitor"); // glid=...|mobile=...|encnum=...
  const issRaw = cookies.get("ht_iss");         // t=<jwt>

  const v = parseKeyValueCookie(visitorRaw);
  const ak = (typeof issRaw === "string" && issRaw.trim().startsWith("t="))
    ? issRaw.trim().slice(2) // remove leading "t="
    : "";

  const hasGlid = !!v.glid;
  const hasEncnum = !!v.encnum;
  const hasAk = !!ak;

  return (hasGlid && hasEncnum && hasAk) ? "login" : "none";
}

/** ht_visitor -> glid=...|mobile=...|encnum=... */
export function getGlid() {
  const raw = cookies.get("ht_visitor");
  const obj = parseKeyValueCookie(raw);
  return obj.glid || "";
}

export function getMobile() {
  const raw = cookies.get("ht_visitor");
  const obj = parseKeyValueCookie(raw);
  return obj.mobile || "";
}

export function getEncNum() {
  const raw = cookies.get("ht_visitor");
  const obj = parseKeyValueCookie(raw);
  return obj.encnum || "";
}

/** ht_iss -> t=<JWT> */
export function getAk() {
  const raw = cookies.get("ht_iss");
  if (typeof raw !== "string" || !raw) return "";
  let decoded = raw;
  if (decoded.includes("%")) {
    try {
      decoded = decodeURIComponent(decoded);
    } catch (error) {
      console.warn("Unable to decode ht_iss cookie", error);
    }
  }
  // Expect format "t=<token>"
  // tolerate optional leading/trailing spaces
  const m = decoded.trim().match(/^t=(.+)$/);
  return m ? m[1] : "";
}

export function decodeJWT(token) {
  if (!token) return null;

  try {
    const payload = token.split(".")[1];
    return JSON.parse(atob(payload.replace(/-/g, "+").replace(/_/g, "/")));
  } catch (e) {
    console.error("Invalid JWT:", e);
    return null;
  }
}

export function getGlidFromJWT(decoded) {
  return decoded?.userDetails?.glid || "";
}

export function getMobileFromJWT(decoded) {
  return decoded?.userDetails?.mobile || "";
}

export function getUserNameFromJWT(decoded) {
  return decoded?.userDetails?.userName || "";
}

const CUSTO_PROFILE_ENCNUM = (process.env.REACT_APP_CUST_PROFILE_ENCNUM || "[]")
  .replace(/[\[\]'"]/g, "")
  .split(",")
  .map(v => v.trim());

export async function fetchStatutoryDetails(mob, isEncryptedToken = false) {
  try {
    const formData = new FormData();

    if (isEncryptedToken) {
      formData.append("auth", mob);
    } else {
      formData.append("mob", mob);
    }
    const fullPath = window.location.pathname + window.location.search;
    formData.append("fullPath", fullPath);
    const apiURL = process.env.REACT_APP_API_GATEWAY_URL_V2 || "https://www.hellotrade.com/api/v1/fetchAllDetailsV2";

    const response = await axios.post(
      apiURL,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response.data;
  } catch (error) {
    writeHtFrontLogDirect({
      glid: "",
      ak: "",
      input: mob,
      output: "",
      issue: String(error),   // stringify error object
      serviceName: "WRITE_FRONTEND_LOG_DIRECT",
      source: "FETCH_ALL_DETAIL_CATCH",
      status: "ERROR",
      code: "500",
      modid: "",
      reqTime: "",
      respTime: "",
      totalTime: "0"
    });
    console.error("Error fetching statutory details:", error);
    return null;
  }
}

export function extractSellerDetails(response) {
  const payload = response?.USER_DATA || response || {};
  const gstDetails = payload?.RESPONSE?.gst_detail || {};
  const userDetails = payload?.RESPONSE?.user_detail || {};

  return {
    sellerName: gstDetails.business_name || "",
    companyName: gstDetails.trade_name || "",
    glid: userDetails.glusr_usr_id || "",
    mobile: userDetails.glusr_usr_ph_mobile || "",
  };
}


export function maskString(input) {
  if (!input || input.length < 6) return input;

  return input
    .split("")
    .map((char, i, arr) =>
      i === 0 || i === 4 || i === 5 || i === arr.length - 1 ? char : "*"
    )
    .join("");
}


export async function markHTLanding(glid, ak, src = "HelloTrade", displayPage = null) {
  if (!glid) {
    //console.log("trying to get GLID")
    glid = getGlid();
  }

  if (!ak) {
    //console.log("trying to get AK")
    ak = getAk();
  }

  try {
    const apiURL = process.env.REACT_APP_MARKHTLAND_LOANS_API_URL || "https://loans.indiamart.com/api/v1/markHTLand";

    // Full query string
    const fullQuery = window.location.search || ""; // e.g. "?encMob=...&userSourceData=loans,&ts=..."
    const queryNoQ = fullQuery.startsWith("?") ? fullQuery.slice(1) : fullQuery;

    // Extract only userSourceData for queryStr, falling back to the full utm_* param set
    const qs = new URLSearchParams(fullQuery);
    let userSourceData = qs.get("userSourceData") || "";
    if (!userSourceData) {
      const utmParams = new URLSearchParams();
      qs.forEach((value, key) => {
        if (key.startsWith("utm_")) utmParams.append(key, value);
      });
      userSourceData = utmParams.toString();
    }

    const isMobile = /Mobi|Android/i.test(navigator.userAgent);

    // Build x-www-form-urlencoded body
    const body = new URLSearchParams();
    body.append("glid", glid || "");
    body.append("src", src || "HelloTrade");
    body.append("device", isMobile ? "Mobile" : "Desktop");
    body.append("queryStr", userSourceData); // userSourceData, or full utm_* params if no userSourceData
    body.append("encUrl", queryNoQ);         // complete query string (no "?")
    body.append("ak", ak || "");
    body.append("displayPage", displayPage !== null ? String(displayPage) : "");

    const response = await axios.post(apiURL, body, {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      timeout: 10000,
    });

    if (response.data?.CODE == "200") {
      return response.data;
    } else {
      console.error("Unexpected response from API:", response.data);
      return "";
    }
  } catch (error) {
    console.error("An error occurred in markHTLanding:", error);
    return "";
  }
}

export function redirectBackToLoans() {
  let baseUrl = process.env.REACT_APP_LOANS_IM_URL || "http://localhost:3002";
  if (baseUrl.includes("?")) baseUrl = baseUrl.split("?")[0];
  let redirectUrl = `${baseUrl}?from=HelloTrade`;

  window.location.href = redirectUrl;
};

export function redirectBackToGoldLoans() {
  let baseUrl = process.env.REACT_APP_LOANS_IM_URL || "http://localhost:3002";
  if (baseUrl.includes("?")) baseUrl = baseUrl.split("?")[0];
  let redirectUrl = `${baseUrl}?from=HelloTrade&origin_ht_page=goldloan`;

  window.location.href = redirectUrl;
};

export function redirectBackToPersonalLoans() {
  let baseUrl = process.env.REACT_APP_LOANS_IM_URL || "http://localhost:3002";
  if (baseUrl.includes("?")) baseUrl = baseUrl.split("?")[0];
  let redirectUrl = `${baseUrl}?from=HelloTrade&origin_ht_page=personalloan`;

  window.location.href = redirectUrl;
};


// Centralized login check
export async function centralizedLoginCheck(
  currentPath,
  queryParams = window.location.search
) {
  const allowedPaths = ["/fixed-deposit", "/pre-approved-offer", "/credit-cards"]; // add more paths as needed
  const currPathPage = allowedPaths.find((p) => currentPath.includes(p));
  const shouldRun = Boolean(currPathPage);

  // console.log("Should run for the Current Path => ", currentPath, "is => ", shouldRun);
  if (!shouldRun) return;

  const loginCookies = checkLoginCookies();
  if (loginCookies == "login") {
    // Log this step use try catch
    let encNumCookie = getEncNum();
    const formRes = await fetchImDataAndSetCookies(encNumCookie); // just to ensure cookies are accessible
    markLanding(currPathPage);
    return formRes;
  }

  const params = new URLSearchParams(queryParams);
  const encMobParam = params.get("encMob") || "";
  const encMob = encMobParam ? decodeURIComponent(encMobParam) : "";

  const imStatus = (params.get("imStatus") || "").toLowerCase() == "true";

  if (encMob) {
    const formRes = await fetchImDataAndSetCookies(encMob);
    markLanding(currPathPage);
    return formRes;
  }

  if (imStatus) {
    return;
  }

  redirectToLoans(currentPath, queryParams);
}


// redirect to loans 
export function redirectToLoans(currentPath, queryParams = "") {
  let parent = "";

  if (currentPath.includes("/fixed-deposit")) {
    parent = "fixed-deposit";
  } else if (currentPath.includes("/pre-approved-offer")) {
    parent = "pre-approved-offer"
  } else if (currentPath.includes("/credit-cards")) {
    parent = "credit-cards"
  }

  const baseUrl = process.env.REACT_APP_LOANS_IM_URL || "https://loans.indiamart.com";

  // Prepare full query string: keep existing params + append parent
  const prevParams = new URLSearchParams(queryParams);
  prevParams.set("origin_ht_page", parent); // add

  const redirectUrl = `${baseUrl}?${prevParams.toString()}`;
  window.location.href = redirectUrl;
}


export async function fetchImDataAndSetCookies(encMob, isEncryptedToken = false) {
  let formRes = await fetchStatutoryDetails(encMob, isEncryptedToken);

  if (formRes && formRes.CODE == 200) {
    let glid = formRes.USER_DATA.RESPONSE.user_detail.glusr_usr_id || "";
    let phn = formRes.USER_DATA.RESPONSE.user_detail.glusr_usr_ph_mobile || "";
    let ak = formRes.TOKEN.t || "";
    // RSA flow: backend returns the imcrypt-encrypted mobile for cookie storage.
    const cookieEncMob = isEncryptedToken ? (formRes.encMob || "") : encMob;

    if (glid && phn && ak && cookieEncMob) {
      setLoginCookies(glid, ak, phn, cookieEncMob);
    } else {
      console.log("Cookie values are empty => ", glid, phn, ak, encMob);
      // Log this step
    }

    return formRes;
  } else {
    // Log this step
    console.log("fetchStatutoryDetails API response not 200")
    return formRes;
  }
}

export async function getEncMobVendor(glid, ak, mob, vendor) {
  if (!glid) glid = getGlid();
  if (!ak) ak = getAk();
  if (!mob) mob = getMobile();

  try {
    const url = process.env.REACT_APP_GETENCMOBVENDOR_API_URL || "";


    const mobData = { glid, ak, mob, vendor };

    const formData = new FormData();
    for (let key in mobData) {
      if (mobData[key] !== undefined && mobData[key] !== null) {
        formData.append(key, mobData[key]);
      }
    }

    const response = await axios({
      method: "post",
      url: url,
      data: formData,
      timeout: 10000,
    });

    const respData = response.data;
    if (respData?.CODE == "200") {
      return respData.OUTPUT;
    }
  } catch (error) {
    console.log("Error in Get Enc for fixerra =>", error);
  }

  return "";
}

export function markLanding(page) {
  const glid = getGlid();
  const ak = getAk();

  const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
  const deviceType = isMobile ? "Mobile" : "Desktop";

  const inputData = `url=${window.location.href}, device=${deviceType}`;

  if (page == "/fixed-deposit") {
    gatrack("FD Journey", "FD Page Landing", "FD Page", glid, "", JSON.stringify(Object.fromEntries(getQueryParamUtils())));
  }

  try {
    writeHtFrontLog({
      glid,
      ak,
      input: inputData,
      output: page,
      status: "SUCCESS",
      serviceName: "HT_LANDING",
      code: "200",
      modid: "NA",
      issue: "",
      reqTime: "",
      respTime: "",
      totalTime: "0",
    });
  } catch (error) {
    writeHtFrontLog({
      glid: glid || "unknown",
      ak: ak || "unknown",
      input: inputData,
      output: page,
      status: "FAILURE",
      serviceName: "HT_LANDING",
      code: "500",
      modid: "NA",
      issue: error?.message || "unknown error",
      reqTime: "",
      respTime: "",
      totalTime: "0",
    });
  } finally {
    if (page == "/pre-approved-offer") {
      let url = window.location.href
      let mob = getMobile();
      writeToSheet(glid, ak, mob, url, 'landing', 'PAPQ');
    }
  }
}

// export async function writeToSheet(glid, ak, mob, url, event, initiator) {
export async function writeToSheet(glid, ak, mob, url, event, initiator, companyName = "", sellerName = "") {
  try {
    const formData = new FormData();
    formData.append("glid", glid);
    formData.append("ak", ak);
    formData.append("mob", mob);
    formData.append("url", url);
    formData.append("event", event);
    formData.append("initiator", initiator);
    formData.append("companyName", companyName);
    formData.append("sellerName", sellerName);

    const apiUrl = process.env.REACT_APP_WRITE_TO_SHEET_API_URL || "";

    const response = await axios.post(apiUrl, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    // console.log("writeToSheet response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error writing to sheet:", error);
  }
};




export async function checkLoanOffer(glid, ak) {
  //return { OUTPUT: true, RESULT: null }; //offer to 0% traffic

  try {
    const formData = new FormData();
    formData.append("glid", glid);
    formData.append("ak", ak);

    const apiUrl = process.env.REACT_APP_CHECK_LOAN_OFFER_LOANS_API_URL || "";

    const response = await axios.post(apiUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error checking loan offer:", error);

  }
};

export async function writeHtFrontLogDirect({
  glid,
  ak,
  input = "",
  output = "",
  issue = "",
  serviceName = "WRITE_FRONTEND_LOG",
  source = "FRONTEND_LOG",
  status = "INFO",
  code = "0",
  modid = "",
  reqTime = "",
  respTime = "",
  totalTime = "0"
}) {

  if (!glid) {
    glid = getGlid();
  }

  const baseUrl = process.env.REACT_APP_HT_BASE_URL || "https://www.hellotrade.com";

  const formData = new FormData();
  formData.append("glid", glid);
  formData.append("ak", ak);
  formData.append("input", input);
  formData.append("output", output);
  formData.append("issue", issue);
  formData.append("serviceName", serviceName);
  formData.append("source", source);
  formData.append("status", status);
  formData.append("code", code);
  formData.append("modid", modid);
  formData.append("reqTime", reqTime);
  formData.append("respTime", respTime);
  formData.append("totalTime", totalTime);

  try {
    const response = await fetch(`${baseUrl}/api/v1/writeHTLogDirect`, {
      method: "POST",
      body: formData,
    });

    const result = await response.json();

    if (result.CODE == "200") {
      console.log("HT log written successfully");
    } else {
      console.warn("HT log write failed", result);
    }
  } catch (err) {
    console.error("Error writing HT log:", err);
  }
}

function getDeviceType() {
  const ua = navigator.userAgent || "";
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
  return isMobile ? "Mobile" : "Desktop";
}


function getStartTimeFromTxnId(trId) {
  if (!trId) return null;
  const parts = trId.split("_");
  if (parts.length < 3) return null;
  const timestamp = Number(parts[1]);
  return isNaN(timestamp) ? null : new Date(timestamp);
}


export function markHtRedirectionStatus(serviceName, glid = "") {
  try {
    const respTime = new Date();
    const urlParams = new URLSearchParams(window.location.search);
    const transactionId = urlParams.get("trId");

    // Only proceed if transactionId is present
    if (!transactionId) {
      return;
    }

    const startTime = getStartTimeFromTxnId(transactionId);

    // totalTime in ms; 0 if startTime missing
    const totalTimeMs = startTime ? respTime - startTime : 0;

    // Get device info
    const device = getDeviceType();

    // Call logging function if not logged in
    writeHtFrontLogDirect({
      glid: glid,
      ak: "",
      input: device,
      output: window.location.search.substring(1), // full query string
      issue: "NA",
      serviceName: serviceName,
      source: transactionId,
      status: "SUCCESS",
      code: "200",
      modid: "HT",
      reqTime: startTime
        ? format(startTime, "dd-MM-yyyy HH:mm:ss.SSS")
        : "",
      respTime: format(respTime, "dd-MM-yyyy HH:mm:ss.SSS"),
      totalTime: totalTimeMs,
    });

    // If logging for HT_USER_DATA_DISPLAYED, remove trId from URL
    if (serviceName === "HT_USER_DATA_DISPLAYED" || serviceName === "HT_LOGIN_DISPLAYED") {
      urlParams.delete("trId");
      const newUrl =
        window.location.pathname +
        (urlParams.toString() ? "?" + urlParams.toString() : "");
      window.history.replaceState({}, document.title, newUrl);
    }
  } catch (err) {
    console.error("Error in markHtRedirectionStatus:", err);
  }
}

export function getBaseUrl() {
  return process.env.REACT_APP_LOANS_IM_URL || "";
}

/**
 * Opens the Free Credit Score page in a new tab
 */
/**
 * Opens a URL in a new tab, falling back to the current tab when the browser
 * refuses the popup.
 *
 * Mobile browsers block window.open far more aggressively than desktop ones —
 * a tap that follows a swipe, or one the browser no longer considers a trusted
 * gesture, gets the popup suppressed and window.open returns null. The CTA then
 * looks completely dead, because the click handler has already called
 * preventDefault() on the anchor. Navigating in place is the correct fallback:
 * the user asked to go there either way.
 */
export function openUrl(url) {
  let win = null;
  try {
    win = window.open(url, "_blank");
  } catch {
    win = null;
  }
  if (!win) {
    window.location.href = url;
  }
  return win;
}

export const goToFcs = () => {
  gatrack("HT_Page", "fcs_cta_click", "free_credit_score_apply_now", null, null, Object.fromEntries(getQueryParamUtils()));

  openUrl("/free-credit-score");
};




/**
 * Navigation action: Opens Business Loan page in a new tab
 */
export function goToBL() {
  gatrack("HT_Page", "bl_cta_click", 'business_loan_check_eligibility', null, null, Object.fromEntries(getQueryParamUtils()));
  openUrl("/businessloan");
}


/**
 * Navigation action: Opens Personal Loan page in a new tab
 */
export function goToPersonalLoan() {
  gatrack("HT_Page", "pl_cta_click", 'personal_loan_apply', null, null, Object.fromEntries(getQueryParamUtils()));
  openUrl("/personalloan");
}


/**
 * Opens Fixed Deposit page in a new tab
 */
export const goToFD = () => {
  window.open("/fixed-deposit", "_blank");
};

/**
 * Navigation action: Opens Credit Cards page with specified card type
 * @param {string} cardType - 'secured' or 'unsecured'
 */
export function goToCreditCards(cardType) {
  gatrack("HT_Page", "CTA_CLICK", cardType, null, null, Object.fromEntries(getQueryParamUtils()));
  const url = `/credit-cards?card_type=${cardType}`;
  window.open(url, "_blank");
}

/**
 * Centralized navigation actions object
 * All header/footer navigation functions should be registered here
 */
export const navigationActions = {
  goToFcs,
  goToBL,
  goToPersonalLoan,
  goToFD,
  goToCreditCards,
};


export async function getBureauNSJourney(formData) {
  const baseUrl = getBaseUrl();
  const apiUrl = `${baseUrl}/api/v1/getBureauNSJourney`;

  try {
    const form = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      form.append(key, value);
    });

    const response = await axios.post(apiUrl, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("❌ Error fetching Bureau NS Journey:", error);
    throw error;
  }
}

export function isBureauLiveTYPage(val) {
  if (val % 2 == 0) {
    return true
  }
  return false;
}

// utils/isNSLive.js
export function isNSLive(glid) {
  if (!glid) return false;

  // Hardcoded live glids (same as your Go function)
  const liveGlids = {
    "132160368": true,
    "236346447": true,
    "29543113": true,
    "13035342": true,
    "59002668": true
  };

  // Check hardcoded map
  if (liveGlids[glid]) {
    return true;
  }

  // Check if glid is even
  const n = parseInt(glid, 10);
  if (!isNaN(n) && n % 2 === 0) {
    return true;
  }

  return false;
}

export const getContactMessage = () => {
  try {
    // Get current time in IST (Asia/Kolkata)
    // The 'hourCycle: h23' ensures the hour is returned in 24-hour format (0-23)
    const now = new Date();
    const istHour = parseInt(
      now.toLocaleString("en-US", {
        hour: "numeric",
        hourCycle: "h23",
        timeZone: "Asia/Kolkata",
      })
    );

    // Check if time is between 9:00 (inclusive) and 18:00 (exclusive, i.e., up to 5:59 PM)
    if (istHour >= 9 && istHour < 18) {
      return "Will contact you within 15 minutes";
    } else {

      return "Your dedicated expert will contact you shortly.";
    }
  } catch (error) {
    // Fallback in case timeZone is not supported (rare, but safe)
    console.error("Timezone error, using default message.");
    return "Will contact you within 15 minutes.";
  }
};

export const getQueryParamUtils = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams;
}

export function getGA4CID() {
  try {
    const gaCookie = document.cookie.split("; ").find(row => row.startsWith("_ga="));
    if (!gaCookie) return null;

    const value = gaCookie.split("=")[1];  // Example: GA1.2.123456789.987654321
    const parts = value.split(".");
    return parts.length > 2 ? `${parts[2]}.${parts[3]}` : null;
  } catch (e) {
    console.error("Error reading GA CID:", e);
    return null;
  }
}

export function getUserType(queryParams) {
  const encMob = queryParams.encMob;
  const imStatus = queryParams.imStatus;

  if (encMob && encMob.trim() !== "") {
    return "IM_LOGGED_IN";
  }

  if (imStatus == "true") {
    return "IM_NON_LOGGED_IN";
  }

  return "HT";
}


export function markUserLanding(pathname) {
  if (!pathname) return;

  const landingPage = pathname;
  const queryParams = Object.fromEntries(getQueryParamUtils());
  const userType = getUserType(queryParams);
  const glid = getGlid();

  gatrack(
    "HT Page",         // Category
    "USER_LANDING",    // Event Action
    landingPage,       // Label
    glid,        // Value
    userType,          // Derived User Type
    Object.fromEntries(getQueryParamUtils())       // Source
  );
}

export function markUserStage(event, label) {
  //const queryParams = Object.fromEntries(getQueryParamUtils());
  const glid = getGlid();

  gatrack(
    "HT Page",         // Category
    event,    // Event Action
    label,       // Label
    glid,        // Value
    null,          // Derived User Type
    Object.fromEntries(getQueryParamUtils())        // Source
  );
}

export function decidePartnerRedirect(currentPath) {
  if (currentPath == "/credit-cards") {
    redirectToCredilio();
  }
  return;
}

export async function redirectToCredilio() {
  try {
    const result = await fetchCredilioData();

    if (!result.success) {
      //console.warn("Credilio redirection blocked:", result.error);
      return { success: false, error: result.error };
    }

    console.log("Redirecting → ", result.url);


    return { success: true, url: result.url };

  } catch (err) {
    //console.error("redirectToCredilio() unexpected failure:", err);
    return {
      success: false,
      error: "Redirection failed unexpectedly",
    };
  }
}


function getCreditCardType() {
  const params = new URLSearchParams(window.location.search);
  return params.get("card_type") || "";
}

async function fetchCredilioData() {
  try {
    const ak = getAk();
    const gaCid = getGA4CID();
    const journeyType = getCreditCardType();
    const host = window.location.hostname;

    // Basic validations
    if (!ak) {
      return { success: false, error: "Missing authorization token" };
    }
    if (!gaCid) {
      return { success: false, error: "GA4 Client ID not found" };
    }
    if (!journeyType) {
      return { success: false, error: "Journey type not detected" };
    }

    const apiUrl = process.env.REACT_APP_GET_CREDILIO_URL_API || "https://www.hellotrade.com/api/v1/getCredilioUrl";

    const body = new URLSearchParams({
      gaCid,
      journeyType,
    });

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${ak}`,
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: body.toString(),
    });

    // Network or CORS failure
    if (!response.ok) {
      return {
        success: false,
        error: `Network error: ${response.status} ${response.statusText}`,
      };
    }

    const json = await response.json();

    // Backend error response
    if (!json || json.CODE !== "200") {
      return {
        success: false,
        error: json?.MESSAGE || "Unexpected backend error",
      };
    }

    // Success
    return {
      success: true,
      url: json.FINAL_URL,
    };
  } catch (err) {
    // console.error("fetchCredilioData() FAILED:", err);
    return {
      success: false,
      error: "Something went wrong. Please try again." + err.message,
    };
  }
}


export async function sendStageAuditEvent({
  stage,
  subStage,
  glid = null,
  ak = null,
  leadId = null,
  encNum = null
}) {
  // Auto-fetch glid and ak from cookies if not provided
  if (!glid) {
    glid = getGlid();
  }
  if (!ak) {
    ak = getAk();
  }

  // Validate required parameters
  if (!stage || typeof stage !== 'string' || stage.trim() === '') {
    console.error("sendStageAuditEvent: stage is required and must be a non-empty string");
    return { success: false, error: "Missing or invalid stage parameter" };
  }

  if (!subStage || typeof subStage !== 'string' || subStage.trim() === '') {
    console.error("sendStageAuditEvent: subStage is required and must be a non-empty string");
    return { success: false, error: "Missing or invalid subStage parameter" };
  }

  if (!glid || glid.trim() === '') {
    console.error("sendStageAuditEvent: glid is required");
    return { success: false, error: "Missing glid parameter" };
  }

  if (!ak || ak.trim() === '') {
    console.error("sendStageAuditEvent: ak is required");
    return { success: false, error: "Missing ak parameter" };
  }

  // Normalize optional parameters to empty strings if not provided
  const normalizedLeadId = leadId !== null && leadId !== undefined ? String(leadId).trim() : '';
  const normalizedEncNum = encNum !== null && encNum !== undefined ? String(encNum).trim() : '';

  try {
    // API URL with environment variable support
    const baseUrl = process.env.REACT_APP_LOANS_BACKEND_PATH
    const apiURL = `${baseUrl}/v1/sendStageAuditEvent` || "https://loans.indiamart.com/api/v1/sendStageAuditEvent";

    // Build form data
    const formData = new FormData();
    formData.append("glid", glid.trim());
    formData.append("ak", ak.trim());
    formData.append("leadId", normalizedLeadId);
    formData.append("stage", stage.trim());
    formData.append("subStage", subStage.trim());
    formData.append("encNum", normalizedEncNum);

    const response = await axios.post(apiURL, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 10000, // 10 second timeout
    });

    if (response.data && response.data.CODE === "200") {
      return {
        success: true,
        data: response.data
      };
    } else {
      const errorMsg = response.data?.error || response.data?.message || "Unknown error";
      console.warn("sendStageAuditEvent: API returned non-success response", response.data);
      return {
        success: false,
        error: errorMsg,
        data: response.data
      };
    }
  } catch (error) {
    // Handle different error types
    if (error.response) {
      // Server responded with error status
      const errorData = error.response.data || {};
      const errorMsg = errorData.error || errorData.message || `HTTP ${error.response.status}`;
      console.error("sendStageAuditEvent: API error response", {
        status: error.response.status,
        data: errorData
      });
      return {
        success: false,
        error: errorMsg,
        data: errorData
      };
    } else if (error.request) {
      // Request made but no response received
      console.error("sendStageAuditEvent: No response received", error.message);
      return {
        success: false,
        error: "Network error: No response from server"
      };
    } else {
      // Error setting up request
      console.error("sendStageAuditEvent: Request setup error", error.message);
      return {
        success: false,
        error: error.message || "Unknown error occurred"
      };
    }
  }
}


/**
 * Gets journey status from API and returns structured decision data
 * Uses new enhanced API response 
 * 
 * @param {string} glid - User GLID
 * @param {string} ak - Authorization token
 * @param {string} productAlias - Product alias 
 * @returns {Promise<Object>} Structured result with displayPage, userInfoUpdates, etc.
 */
export async function getJourneyStatusDB(glid, ak, productAlias) {
  const url = process.env.REACT_APP_GET_JOURNEY_STATUS_LOANS_API ||
    "https://loans.indiamart.com/api/v1/getJourneyFlags";

  const postData = {
    glid: glid,
    stage: "raw",
    ak: ak,
    product_alias: productAlias
  };

  const formData = new FormData();
  for (const key in postData) {
    if (postData.hasOwnProperty(key)) {
      formData.append(key, postData[key]);
    }
  }

  // Excluded GLIDs from environment variable
  const excludedGlidsEnv = process.env.REACT_APP_EXCLUDED_GLIDS || "132160368";
  const excludedGlids = excludedGlidsEnv
    .split(",")
    .map(g => g.trim())
    .filter(g => g.length > 0);

  try {
    const response = await axios({
      method: "post",
      url: url,
      data: formData,
      timeout: 10000,
    });

    const data_obj = response.data;

    // Default return structure
    const defaultReturn = {
      success: false,
      displayPage: 1, // Form Page
      userInfoUpdates: {},
      shouldSetJourneyCheckDone: true,
      reason: "default_fallback"
    };

    if (!data_obj || data_obj.code != "200") {
      console.error("Data object not present in journey stat API or CODE is not 200");
      return {
        ...defaultReturn,
        reason: "api_error_or_invalid_code"
      };
    }

    // Use shouldShowFormPage for page routing decisions
    // Get leadID from existingLeadID (new API field)
    const leadID = data_obj.leadID > 0 ? data_obj.leadID : null;

    // Priority 1: Check shouldShowFormPage first (primary routing decision)
    if (data_obj.shouldShowFormPage === true) {
      console.log("here isn the should sdhsow form page")
      return {
        success: true,
        displayPage: 1, // Form Page
        userInfoUpdates: {},
        shouldSetJourneyCheckDone: true,
        reason: "should_show_form_page_true"
      };
    }

    // If shouldShowFormPage is false or empty, we need a valid leadID to show other pages
    // If no valid leadID exists, show Form Page as fallback
    if (!leadID || leadID <= 0) {

      console.log("should leadID <=09")
      return {
        success: true,
        displayPage: 1, // Form Page
        userInfoUpdates: {},
        shouldSetJourneyCheckDone: true,
        reason: "should_show_form_page_false_no_leadid"
      };
    }

    // We have a valid leadID and shouldShowFormPage is false/empty
    // Continue with old routing logic to determine which page to show

    if (data_obj.currentPage.currentPage) {
      console.log("found Cureent page")
      return {
        success: true,
        displayPage: guardAaOnlyPage(glid, data_obj.currentPage.currentPage),
        userInfoUpdates: {
          leadID: leadID
        },
        shouldSetJourneyCheckDone: true,
        reason: "current_page_found"
      };

    }

    // Check excluded GLIDs
    if (excludedGlids.includes(glid)) {
      console.log("exclude glidsasdja")
      return {
        success: true,
        displayPage: 1, // Form Page
        userInfoUpdates: {},
        shouldSetJourneyCheckDone: true,
        reason: "excluded_glid"
      };
    }

    // Check bankingStatus
    if (data_obj.bankingStatus == "true") {
      console.log("banking_status_true")
      return {
        success: true,
        displayPage: 4, // Thanks Page
        userInfoUpdates: {
          leadID: leadID
        },
        shouldSetJourneyCheckDone: true,
        reason: "banking_status_true"
      };
    }

    if (data_obj.bankingStatus != "true" && leadID > 0) {
      return {
        success: true,
        displayPage: resolveBankingEntryPage(glid),
        userInfoUpdates: {
          leadID: leadID
        },
        shouldSetJourneyCheckDone: true,
        reason: "banking_status_false_with_leadid"
      };
    }

    // Default: Show Form Page
    return {
      success: true,
      displayPage: 1, // Form Page
      userInfoUpdates: {},
      shouldSetJourneyCheckDone: true,
      reason: "default_form_page"
    };

  } catch (error) {
    console.error("Error fetching journey Status:", error);
    return {
      success: false,
      displayPage: 1, // Form Page
      userInfoUpdates: {},
      shouldSetJourneyCheckDone: true,
      reason: `error_${error.message || "unknown"}`
    };
  }
}

export async function refreshSellerData(glid, ak) {
  const resolvedGlid = glid || getGlid();
  const resolvedAk = ak || getAk();

  if (!resolvedGlid || !resolvedAk) {
    return null;
  }

  try {
    const baseUrl = process.env.REACT_APP_HELLOTRADE_API_BASE_URL || "";
    const formData = new FormData();
    formData.append("glid", resolvedGlid);
    formData.append("ak", resolvedAk);

    const response = await axios.post(`${baseUrl}/v1/refreshSellerData`, formData, {
      timeout: 25000,
    });

    return response.data;
  } catch (error) {
    console.error("refreshSellerData error:", error);
    return null;
  }
}

export async function checkLeadEligibility(glid, ak) {
  const baseUrl = process.env.REACT_APP_BACKEND_PATH || "https://loans.indiamart.com/api";
  const url = `${baseUrl}/v1/checkLeadEligibility`;

  const formData = new URLSearchParams();
  formData.append("glid", glid || getGlid() || "");
  formData.append("ak", ak || getAk() || "");
  formData.append("product_alias", "unsecured_business_loan");

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: formData.toString(),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error in checkLeadEligibility helper:", error);
    return null;
  }
}

export async function getApprovedLoanAmount(leadId) {
  const baseUrl = process.env.REACT_APP_HELLOTRADE_API_BASE_URL || "https://www.hellotrade.com/api";
  const url = `${baseUrl}/v2/getApprovedLoanAmount?lead_id=${leadId}`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error in getApprovedLoanAmount helper:", error);
    return null;
  }
}

/**
 * GET rejection level for a lead. glid and ak are read from cookies (ht_visitor / ht_iss).
 * Sample: /v1/getLeadRejectionLevel?glid=...&ak=...&leadId=...
 */
export async function getLeadRejectionLevel(leadId) {
  const baseUrl = (process.env.REACT_APP_BACKEND_PATH || "https://loans.indiamart.com/api").replace(
    /\/$/,
    ""
  );
  const path =
    process.env.REACT_APP_GET_LEAD_REJECTION_LEVEL_PATH || "v1/getLeadRejectionLevel";
  const glid = getGlid();
  const ak = getAk();
  const params = new URLSearchParams({
    glid: String(glid || ""),
    ak: String(ak || ""),
    leadId: String(leadId ?? ""),
  });
  const url = `${baseUrl}/${path.replace(/^\//, "")}?${params.toString()}`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error in getLeadRejectionLevel:", error);
    return null;
  }
}

/** Returns rejection level (L1, L2, OTHER, etc.) from API result, or null. */
export function getGoldLoanRejectionLevelFromResponse(data) {
  if (!data) return null;
  const rawCode = data.code ?? data.CODE;
  const codeOk = rawCode === 200 || String(rawCode ?? "").trim() === "200";
  if (!codeOk) return null;
  const result = data.result || {};
  const level = String(result.rejectionLevel ?? result.rejection_level ?? "")
    .trim()
    .toUpperCase();
  // Return null for NOT_REJECTED (success case)
  if (level === "NOT_REJECTED") return null;
  // Return any rejection level (L1, L2, OTHER, etc.) if present
  return level || null;
}

/** True when API returns L1/L2 in result — route Thanks to gold-loan ThankYouPageComponent. */
export function shouldShowGoldLoanThanksFromRejectionLevel(data) {
  return getGoldLoanRejectionLevelFromResponse(data) != null;
}

export const PagesMapping = {
  1: "1_PI_DETAILS",
  2: "OTP",
  3: "2_BANKING",
  4: "4_THANKS",
  5: "MORE_DETAILS",
  6: "3_UPLOAD_DOCUMENTS",
  7: "5_MASKED_MOBILE",
  8: "6_MASKED_MOBILE_OTP",
  10: "2_BANKING_CHOICE",
  11: "2_BANKING_AA",
  12: "FLDG_THANKS",
  13: "2_BANKING_NET_BANKING",
};

export async function captureApply({ glid, ak, bname, iname, pan, storeData }) {
  const apiURL = process.env.REACT_APP_CAPTURE_APPLY_API_URL || "https://www.hellotrade.com/api/v1/captureApply";
  const inData = { glid, ak, bname, iname, pan, storeData };
  const formData = new FormData();
  for (const key in inData) formData.append(key, inData[key]);
  const response = await axios({ method: "post", url: apiURL, data: formData, timeout: 10000 });
  return response.data;
}

export async function applyClickV2({ glid, ak, bname, cust_name, pan_number, phone_number, landing_record_id }) {
  const apiURL = process.env.REACT_APP_APPLY_CLICK_LOANS_API_V2 || "https://dev-loans.indiamart.com/api/v1/applyClickV2";
  const inData = { glid, ak, bname, cust_name, pan_number, phone_number, landing_record_id };
  const formData = new FormData();
  for (const key in inData) formData.append(key, inData[key]);
  const response = await axios({ method: "post", url: apiURL, data: formData, timeout: 10000 });
  return response.data.RESULT;
}

export const isV4Cohort = (glid) => {
  if (!glid) return false;
  const lastDigit = String(glid).slice(-1);
  return ['1', '7', '4', '8'].includes(lastDigit);
};

export {
  isAaRolloutLimited,
  isAaLive,
  resolveBankingEntryPage,
  guardAaOnlyPage,
  showBankingAaQuickFetch,
} from "./config/aaRollout";

export {
  isFldgRolloutLimited,
  isFldgJourneyLive,
} from "./config/fldgRollout";

export {
  isNetBankingRolloutLimited,
  isNetBankingLive,
  guardNetBankingPage,
} from "./config/netBankingRollout";

// grantsConsent: pass true ONLY from the explicit apply flow (consent checkbox
// checked + submit), where the backend records a fresh consent. Defaults to false
// so background/re-check callers (e.g. journey restore) never mark consent — they
// must respect the real check-consent result. grantsConsent is frontend-only and
// is not sent to the backend.
export async function initiateBureau({ glid, lead_id, name, mobile_no, pan, ak, product, grantsConsent = false }) {
  const baseURL = process.env.REACT_APP_HELLOTRADE_API_BASE_URL || "http://localhost:3005/api";
  const apiURL = `${baseURL}/v1/initiate-bureau`;
  const response = await axios({
    method: "post",
    url: apiURL,
    headers: { "Content-Type": "application/json" },
    data: { glid, lead_id, name, mobile_no, pan, ak, product },
  });
  // Only an explicit apply records consent on the backend. Signal that so the
  // consent cache (ConsentContext) refreshes and doesn't show the consent modal
  // on a later consent page.
  if (grantsConsent) {
    try {
      window.dispatchEvent(new CustomEvent('ht:consent-granted', { detail: { glid } }));
    } catch (e) {
      // dispatch is best-effort; never block the bureau flow
    }
  }
  return response.data;
}

export async function sendBureauOtp({ mobile_no, mobile_nos, stgOneHitId }) {
  const baseURL = process.env.REACT_APP_HELLOTRADE_API_BASE_URL || "http://localhost:3005/api";
  const apiURL = `${baseURL}/v1/bureau-send-otp`;
  const response = await axios({
    method: "post",
    url: apiURL,
    headers: { "Content-Type": "application/json" },
    data: { mobile_no, mobile_nos, stgOneHitId },
  });
  return response.data;
}

// glid/lead_id/ak are required — the backend uses them to trigger
// authenticate-delivery-data itself as the direct consequence of a verified
// OTP. There is no separate authenticateDeliveryData call from the frontend
// any more: that endpoint isn't exposed on its own, precisely so OTP can't
// be skipped by calling delivery-auth directly.
export async function validateBureauOtp({ mobile_no, otp, groupId, glid, lead_id, ak, stgTwoHitId }) {
  const baseURL = process.env.REACT_APP_HELLOTRADE_API_BASE_URL || "http://localhost:3005/api";
  const apiURL = `${baseURL}/v1/bureau-validate-otp`;
  const response = await axios({
    method: "post",
    url: apiURL,
    headers: { "Content-Type": "application/json" },
    data: { mobile_no, otp, groupId, glid, lead_id, ak, stgTwoHitId },
  });
  return response.data;
}

export async function triggerWhatsAppOptIn(glid, mobileNumber, ak, pan) {
  if (!glid || !mobileNumber) {
    console.warn("Skipping WhatsApp Opt-In: glid or mobileNumber is missing.");
    return null;
  }

  let formattedMobile = String(mobileNumber).trim();
  if (formattedMobile.length === 10 && !formattedMobile.startsWith("+")) {
    formattedMobile = `+91${formattedMobile}`;
  }

  const finalPan = pan || sessionStorage.getItem("pan") || localStorage.getItem("pan") || sessionStorage.getItem("pan_number") || localStorage.getItem("pan_number") || "";

  try {
    const baseURL = process.env.REACT_APP_LOANS_BACKEND_PATH || "http://localhost:3005/api";
    const apiURL = `${baseURL.replace(/\/$/, "")}/v1/whatsapp/optin`;

    const response = await axios({
      method: "post",
      url: apiURL,
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        glid: String(glid),
        mobile_number: formattedMobile,
        ak: ak,
        pan: finalPan,
      },
    });

    return response.data;
  } catch (error) {
    console.error("WhatsApp Opt-In failed:", error);
    return null;
  }
}